import React from "react";
import { Helmet } from "react-helmet-async";

export default function Terms() {
    return (
        <>
            <Helmet><title>Terms of Service — OpenCSV</title></Helmet>
            <section className="border-b border-black/10">
                <div className="mx-auto max-w-3xl px-4 md:px-8 py-20">
                    <div className="ui-heading text-xs uppercase tracking-widest text-ink-muted mb-4">/ legal</div>
                    <h1 className="font-display font-black tracking-tighter text-4xl md:text-5xl">Terms of Service</h1>
                    <p className="mt-2 text-xs text-ink-muted">Last updated: {new Date().toLocaleDateString()}</p>
                    <div className="mt-8 space-y-6 text-sm text-ink-soft leading-relaxed">
                        <section>
                            <h2 className="ui-heading font-bold text-ink text-lg">1. Acceptance</h2>
                            <p>By creating an OpenCSV account or using opencsv.io, you agree to these Terms. If you do not agree, do not use the service.</p>
                        </section>
                        <section>
                            <h2 className="ui-heading font-bold text-ink text-lg">2. Your account</h2>
                            <p>You are responsible for maintaining the confidentiality of your password and for activity under your account. Notify us immediately of any unauthorized use.</p>
                        </section>
                        <section>
                            <h2 className="ui-heading font-bold text-ink text-lg">3. Lifetime access</h2>
                            <p>"Pro access" means access to paid features (edit, cloud save, exports, AI) for the duration of your active subscription, your active 14-day trial, or your legacy $1 lifetime grant. Subscriptions auto-renew at the end of each billing period unless you cancel before then. Cancel anytime from your Account page. Full refund available within 30 days of any charge — email refunds@opencsv.io.</p>
                        </section>
                        <section>
                            <h2 className="ui-heading font-bold text-ink text-lg">4. Acceptable use</h2>
                            <p>Don't use OpenCSV to host illegal, infringing, or malicious content. Don't reverse-engineer or attempt to disrupt the service. Don't share your account beyond your immediate household.</p>
                        </section>
                        <section>
                            <h2 className="ui-heading font-bold text-ink text-lg">5. Content ownership</h2>
                            <p>You own the CSV files you upload or create. We claim no rights to them. We will never read, sell, or share your file contents.</p>
                        </section>
                        <section>
                            <h2 className="ui-heading font-bold text-ink text-lg">6. Disclaimer</h2>
                            <p>OpenCSV is provided "as is" without warranty of any kind. We are not liable for data loss; please keep backups of important files.</p>
                        </section>
                        <section>
                            <h2 className="ui-heading font-bold text-ink text-lg">7. Contact</h2>
                            <p>Questions? Reach us at flyingfitz@gmail.com.</p>
                        </section>
                    </div>
                </div>
            </section>
        </>
    );
}
